import React from 'react';
import styled from 'styled-components';
import isEmpty from 'lodash/isEmpty';

import { toFriendlyDateString } from 'helpers/Formatter';
import { leaseCreatorColors } from 'helpers/ColorHelper';

import { LeaseCreatorFormItem } from '../common/LeaseCreatorFormItem';
import { VerticalFormWrapper } from 'components/ui/VerticalFormWrapper';

import Col from 'components/ui/Col';
import Row from 'components/ui/Row';
import { sizes } from 'helpers/MediaHelper';
import { responsive } from 'helpers/StyleHelper';

const StyledRow = styled(Row)`
  width: 100%;
  margin-bottom: ${(props) => props.mb || '21px'};
  margin-top: ${(props) => props.mt || '0px'};
`;

const StyledValues = styled.div`
  line-height: 24px;
  color: ${leaseCreatorColors.INFORMATION};
`;

const RentableItem = ({ asset, selectedValues }) => {
  if (isEmpty(asset)) return null;

  const isMobile = window.matchMedia(`(max-width: ${sizes.mobile}px)`).matches;
  const labelSize = isMobile ? responsive.text.mobile : responsive.text.desktop;

  return (
    <React.Fragment>
      <VerticalFormWrapper>
        <StyledRow gutter={8} mb="8px">
          <Col md={8}>
            <LeaseCreatorFormItem label="Asset number" labelSize={labelSize}>
              <StyledValues>{asset.asset_number}</StyledValues>
            </LeaseCreatorFormItem>
          </Col>

          <Col md={8}>
            <LeaseCreatorFormItem label="Monthly rent" labelSize={labelSize}>
              <StyledValues>{`$${selectedValues.monthly_rent.toFixed(2)}`}</StyledValues>
            </LeaseCreatorFormItem>
          </Col>

          <Col md={8}>
            <LeaseCreatorFormItem label="Rental deposit" labelSize={labelSize}>
              <StyledValues>{`$${selectedValues.deposit_amount.toFixed(2)}`}</StyledValues>
            </LeaseCreatorFormItem>
          </Col>
        </StyledRow>
        <StyledRow gutter={8} mb="8px">
          <Col md={8}>
            <LeaseCreatorFormItem label="Key deposit" labelSize={labelSize}>
              <StyledValues>{`$${selectedValues.key_deposit.toFixed(2)}`}</StyledValues>
            </LeaseCreatorFormItem>
          </Col>

          <Col md={8}>
            <LeaseCreatorFormItem label="Start date" labelSize={labelSize}>
              <StyledValues>{toFriendlyDateString(selectedValues.start_date)}</StyledValues>
            </LeaseCreatorFormItem>
          </Col>

          <Col md={8}>
            <LeaseCreatorFormItem label="End date" labelSize={labelSize}>
              <StyledValues>{toFriendlyDateString(selectedValues.end_date)}</StyledValues>
            </LeaseCreatorFormItem>
          </Col>
        </StyledRow>
      </VerticalFormWrapper>
    </React.Fragment>
  );
};

export { RentableItem };
